import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Expert Restricted" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-expert-restricted-route"
    }}>{`Clair Obscur: Expedition 33 Expert Restricted Route`}</h1>
    <h2 {...{
      "id": "attention"
    }}>{`ATTENTION`}</h2>
    <p>{`This route is outdated in favor of `}<a parentName="p" {...{
        "href": "/Expedition-33/Any-Expert-NMG"
      }}>{`this route`}</a>{`.`}</p>
    <p>{`Last update: 6/13/25`}</p>
    <p><strong parentName="p">{`Patch update 6/10/25`}</strong>{`: You can no longer interact with flags during dialogue.`}<br parentName="p"></br>{`
`}{`Here are the affected areas to my current knowledge and potential fixes:`}</p>
    <ul>
      <li parentName="ul">{`Manor & Old Lumiere flags: After Picto menu, reload most recent autosave to cancel dialogue.`}</li>
      <li parentName="ul">{`Sirene: Use flag at camp, or before Glissando.`}</li>
    </ul>
    <p>{`Lampmaster phase 1 4 lamp attack can now no longer be countered. This is actually good for us since we can now parry all 4 for more AP.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "maelle-450hp-024-027"
      }}>{`Maelle 450HP (0:24-0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Option 1: Attack > Parry > Overcharge > Parry > Attack (0:24 w/crit, 0:27 without)`}<br parentName="p"></br>{`
`}{`Option 2: Attack > Parry > Attack > Parry 2, dodge 1, Overcharge (0:26). If you get hit instead of dodging add 1 shot.`}</p>
      <p>{`On average, optimal choice is probably to go for Option 2 if you don't get the parry crit T1.`}</p>
    </Menu>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot Weak Spot, Attack > Parry`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "portier-450hp-10xp-75-016-dodger-0-2-chroma-catalyst"
      }}>{`Portier 450HP 10XP $75 (0:16) Dodger, 0-2 Chroma Catalyst`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`For the attack party attack, start mashing dodge as soon as his arms touch together. After 3 dodges, parry.`}</p>
      </blockquote>
      <p>{`Parry to kill.`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`First strike the Lanceram before the house.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-lancelier-240hp-021"
      }}>{`2 Lancelier 240HP (0:21)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`53XP $144 Lanceram LV1`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spots, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`Parry.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Attack`}</li>
      </ul>
    </Menu>
    <p>{`You can jump up to the right side before the house, or take the path through the house.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Energy Tint Shard`}</strong>{`, `}<strong parentName="p">{`$360 Chroma`}</strong>{` in house detour.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Afterwards, jump off to the left and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First strike the Abbest on your left.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-volester-abbest-010"
      }}>{`2 Volester Abbest (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$216, 55XP`}<br parentName="p"></br>{`
`}{`If you missed XP earlier, take the fight before Eveque instead. Strat for that fight is in the archive section of these notes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot each Volester 3 times, don't hit weakness.`}</li>
            <li parentName="ul">{`Shoot Abbest weakness, skip.`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Ice Lance (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` under the bridge. Go to Flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +9 Might (9)`}</li>
        <li parentName="ul">{`Lune: +8 Might (8), +1 Agility (1)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot, Powerful (in that order)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "eveque-4524-215"
      }}>{`Eveque 4524 (2:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Stop countering Eveque on this turn, until you do the Overcharge.`}<br parentName="p"></br>{`
`}{`Parries on Abbests are optional, assuming you don't need Gustave Charge.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Nothing / Empowering Tint`}</li>
        <li parentName="ul">{`Gustav: Optionally shoot Abbests to kill, Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}<br parentName="p"></br>{`
`}{`If it was no crit and Eveque is still healthy, don't counter it's attack so it starts charging up. You can then inflict a good chunk of damage by shooting the core again.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$333`}</strong>{` along path.`}</p>
    <p>{`Fight the 2 Denerim along the path.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-demineur-218hp-006"
      }}>{`2 Demineur 218HP (0:06)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`713XP $266`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot bombs, then shoot heads.`}</p>
    </Menu>
    <p>{`Take the detour to the right by the tunnel to spawn 3 Denerim and fight them.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-demineur-218hp-005"
      }}>{`3 Demineur 218HP (0:05)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1180XP $399`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot the 3 bombs`}</p>
    </Menu>
    <p>{`Go to Manor.`}</p>
    <p>{`After getting Maelle menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +2 Might (11), +7 Agility (7)`}</li>
        <li parentName="ul">{`Maelle: +1 Agi (1), +14 Might (14)`}</li>
        <li parentName="ul">{`Lune: +4 Might (12), +5 Agility (6)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-curator-3902hp-028"
      }}>{`The Curator 3902HP (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`720XP, $376`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Skip`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Noco and fight him.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "noco-1670hp-023"
      }}>{`Noco 1670HP (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`486XP $200 `}</p>
      </blockquote>
      <p>{`Offensive Shift > Parry > Spark`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Exposing Attack ($3600)`}</strong>{`. Had 2137 left. After Noco continue straight.`}</p>
    <p>{`Do sidequest for `}<strong parentName="p">{`Denerim`}</strong>{`.`}</p>
    <p>{`After Coral Cave flag pick up `}<strong parentName="p">{`$333`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Fight the `}<strong parentName="p">{`Bruler & Cruleram`}</strong>{` that jump down from the ceiling.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "bruler--cruleram-028"
      }}>{`Bruler & Cruleram (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1069XP, $400, 2 Chroma Catalyst?`}</p>
        <h5 parentName="blockquote" {...{
          "id": "turn-1-4"
        }}>{`Turn 1`}</h5>
        <ul parentName="blockquote">
          <li parentName="ul">{`Gustav: Marking Shot Bruler`}</li>
          <li parentName="ul">{`Lune: Wildfire`}</li>
          <li parentName="ul">{`Maelle: Shoot Bruler Weakpoint, Swift Strike Bruler`}</li>
        </ul>
      </blockquote>
      <p>{`Dodge Cruleram, no need to parry.`}</p>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Cruleram`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee Cruleram`}</li>
      </ul>
    </Menu>
    <p>{`Continue through between the seaweeds and pick up `}<strong parentName="p">{`$665`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Cruleram`}</li>
        <li parentName="ul">{`Maelle: Bruleram`}</li>
        <li parentName="ul">{`Lune: Deminerim`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "goblu-22815hp-137"
      }}>{`Goblu 22815HP (1:37)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3240XP, $1330, 0-2? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overload`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, try to setup Marking Shot > Percee again.`}</p>
    </Menu>
    <h3 {...{
      "id": "camp"
    }}>{`Camp`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-2"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "ancient-sanctuary"
    }}>{`Ancient Sanctuary`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you've been hitless since getting Maelle, you can use the flag at the start here for Maelle Might. If so, you can skip Powerful vs Robust Sakapatate.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "robust-sakapatate-5792hp-039"
      }}>{`Robust Sakapatate 5792HP (0:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1824XP, $435, Sakaram Lv.4`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Swings with it's partner: 1 Hit AoE`}</li>
          <li parentName="ul">{`Slams it's shield: 1 Hit AoE, raises Shield and will counter next time its hit.`}</li>
          <li parentName="ul">{`Shield counter: 1 hit AoE, need to dodge sooner than Slams it's shield.`}</li>
          <li parentName="ul">{`Clunky Combo: 2 hit, jump, 1 hit. Has easy audio cue`}</li>
        </ul>
      </blockquote>
      <p>{`Parry his shield attack (prevents him countering later). You can dodge everything else.`}</p>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation (Fail QTE)`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Strike (Fail QTE)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Talk to flag before Ultimate Sakapatate`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +9 Might (23)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ultimate-sakapatate-28236hp-144"
      }}>{`Ultimate Sakapatate 28236HP (1:44)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8100XP, $1930, Breaker + 3 Polished Catalyst + 0-2 Recoats`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Slams the ground: 1 hit AoE, naturally parry timing.`}</li>
          <li parentName="ul">{`Fires it's Cannons: look for Fire on it's cannons as indicator, parry when you see it.`}</li>
          <li parentName="ul">{`Slams it's shield: 1 hit single target.`}</li>
          <li parentName="ul">{`Combo: 2 hits into jump, dodge the first 2 no point in parrying.`}</li>
          <li parentName="ul">{`Launches weird elecric things: 3 hit single target: Parry once they're top of their arc / flying down.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot once, then shoot shoulder 3 times to break it. Attack.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Gustave doesn't have 5AP, you can Powerful instead, or just Attack.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Energy Tint Gustave if he has 0 AP.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, repeat turn 4`}</p>
    </Menu>
    <h3 {...{
      "id": "gestral-village"
    }}>{`Gestral Village`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Degagement, Rain of Fire`}</li>
      </ul>
    </Menu>
    <p>{`Go talk to Jujubree (Merchant).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished Chrome Catalyst (2000)`}</li>
        <li parentName="ul">{`Critical Moment (5520)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment > Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "tournament"
    }}>{`Tournament`}</h3>
    <p>{`Pattern for first 3 fights: Parry, `}<strong parentName="p">{`Degagement`}</strong>{`, Parry, Rain of Fire`}<br parentName="p"></br>{`
`}{`Rewards for each: 2026XP, $366`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "bertrand-big-hands-023"
      }}>{`Bertrand Big Hands (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Swinging Right Hook x2, Left Uppercut (parry end of windup)`}</p>
      </blockquote>
      <h4 {...{
        "id": "dominique-giant-feet-028"
      }}>{`Dominique Giant Feet (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Two-handed Ground Pound x2, Right Handed Ground Pound (Parry indicator is his elbow pointing up)`}</p>
      </blockquote>
      <h4 {...{
        "id": "matthieu-the-colossus-025"
      }}>{`Matthieu the Colossus (0:25)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Left Hook x2, Right `}<strong parentName="p">{`Feint`}</strong>{` into Left Uppercut (Parry as he swings)`}</p>
      </blockquote>
      <h4 {...{
        "id": "sciel-3211hp-024"
      }}>{`Sciel 3211HP (0:24)`}</h4>
      <p>{`Parry, Rain of Fire, Parry`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sealed Fate: 3 Hit`}</li>
          <li parentName="ul">{`Twilight Slash: 1 Hit`}</li>
          <li parentName="ul">{`Marking Card: 2 hit projectile, Parry as circle closes.`}</li>
        </ul>
      </blockquote>
      <p>{`You need to win vs Sciel for this route.`}</p>
    </Menu>
    <p>{`Talk to Golgra and leave the village.`}</p>
    <h4 {...{
      "id": "camp-1"
    }}>{`Camp`}</h4>
    <p>{`Sleep. Go to Esquie's Nest.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim`}</li>
        <li parentName="ul">{`Maelle: Medalum`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Go to flag by entrance.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +13 Agility (20) (2 less than max, saves a turn vs Renoir)`}</li>
        <li parentName="ul">{`Lune: +2 Might (14), +3 Agility (9), +10 Luck (10)`}</li>
        <li parentName="ul">{`Maelle: +9 Might (32)`}</li>
        <li parentName="ul">{`Sciel: +45 Might (45)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Thunderfall, Lightning Dance`}</li>
        <li parentName="ul">{`Lune: Equip Lightning Dance to Bottom Left slot`}</li>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Phantom Blade`}</strong>{`, Rush, Spectral Sweep, Dark Cleansing, Intervention`}</li>
        <li parentName="ul">{`Sciel: Equip Intervention to Top Left slot`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "francois-9652hp-018"
      }}>{`Francois 9652HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2228XP, $392, 345SPD, Augmented First Strike + 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Dodge his attacks, use rhythm like Eveque spells`}</p>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Shoot 3 times, Attack`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Backtrack to Esquie.`}<br parentName="p"></br>{`
`}{`After talking to Esquie, run to flag by Francois and fast travel to entrance.`}</p>
    <h3 {...{
      "id": "the-continent"
    }}>{`The Continent`}</h3>
    <p>{`Picked `}<strong parentName="p">{`Colour of Lumina`}</strong>{` by the Demineur, Lancelier, Crueler. Then camp.`}</p>
    <h4 {...{
      "id": "camp-2"
    }}>{`Camp`}</h4>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +4 (7)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +2 Lumina (13)`}</li>
        <li parentName="ul">{`Sciel: +1 Lumina (16)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "the-continent-1"
    }}>{`The Continent`}</h3>
    <p>{`First strike the group here.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-crueler-lancelier-020"
      }}>{`Demineur, Crueler, Lancelier (0:20)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4333XP, $914, Lanceram LV6 Cruleram LV6`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Lancelier Weakpoint`}</li>
            <li parentName="ul">{`Shoot Demineur Mine`}</li>
            <li parentName="ul">{`Marking Shot Crueler (1 Right)`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Headshot Demineur`}</li>
            <li parentName="ul">{`Shoot Lancelier 7 times`}</li>
            <li parentName="ul">{`Percee Crueler`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` on beach west of `}<strong parentName="p">{`Stone Wave Cliffs`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{` after breaking the rocks to Stone Wave Cliffs`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` on the left before the 1st flag.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$790`}</strong>{` to right of rope up big pipe.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$790`}</strong>{` after Farm flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Breaker`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(L2) +Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lampmaster-42677hp-151"
      }}>{`Lampmaster 42677HP (1:51)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`18900XP, $3160, 3 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need > 310 speed to outspeed him T2. 312 confirmed working.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Switches off lights and attacks: 4 Lamps launch projectiles. Parry when lamps turn off.`}</li>
          <li parentName="ul">{`Jumps: Parry on landing.`}</li>
          <li parentName="ul">{`Power of its lamps: 1 Dark Attack, visual/audio pre attack cue?`}</li>
          <li parentName="ul">{`Tries to blind: 3 Physical, first swipe is later than it looks.`}</li>
          <li parentName="ul">{`Dark explosion: jumps and hits 1 on landing.`}</li>
        </ul>
      </blockquote>
      <p>{`Can dodge all his attacks, don't want counter animations. Only benefit to parrying is to build enough AP to skip an energy tint.`}</p>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustav: Energy Tint Lune`}</li>
        <li parentName="ul">{`Sciel: Energy Tint Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Enter phase 2.`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Flying Combo: 4 hits, parry bit after audio cue`}</li>
          <li parentName="ul">{`Attacks with each arm: 4 hits, parry on audio cue?`}</li>
          <li parentName="ul">{`Vast ball of light: Jump, easy timing`}</li>
          <li parentName="ul">{`Sword of light: 1 hit, parry during it's swing at you`}</li>
        </ul>
      </blockquote>
      <p>{`He will do 1 of first 3 moves into ritual into Sword of Light. If no Dodger on Lune Parry Sword of Light for AP.`}<br parentName="p"></br>{`
`}{`If he didn't do Vast ball of light might need burn damage to kill.`}</p>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Attack`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "white-haired-man-049"
    }}>{`White-Haired Man (0:49)`}</h4>
    <p>{`Skip turn x4`}</p>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <p>{`Start off at camp, party full healed. Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (18)`}</li>
        <li parentName="ul">{`Verso: +32 Might (32), +10 Agility (10)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Marking Shot, `}<strong parentName="li">{`Perfect Recovery`}</strong>{`, Quick Strike, Berserk Slash, Defiant Strike`}</li>
        <li parentName="ul">{`Verso: Equip Defiant Strike to Right-Bottom, Equip Berserk Slash Left-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Do this menu before entering `}<strong parentName="p">{`Forgotten Battlefield`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-3"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Exposing Attack`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chalier-9724hp-025"
      }}>{`Chalier 9724HP (0:25)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4134XP (NB), $593, 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Dodge 1st attack`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Let Verso die to Gradient`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{` from Merchant ($9870).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle`}</li>
        <li parentName="ul">{`+Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "dualiste-71106hp-141215"
      }}>{`Dualiste 71106HP (1:41/2:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33072XP, $3950, Dualiso + Combo Attack I + 3 Polished Chroma Catalyst + 0-1 Recoat?`}<br parentName="p"></br>{`
`}{`Threshold between him getting 2 attacks before you is somewhere between 328 and 318 speed.`}</p>
      </blockquote>
      <p>{`Good or bad fight depends on targetting, bad fight loses ~30s.`}<br parentName="p"></br>{`
`}{`1st phase you need Sciel or Verso. 2nd phase you NEED Verso target at the start. If you don't get the right moves turn 1, you can refer to mediocre fight below.`}</p>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Note that if you hit all crits and he targets Verso with the jump attack move, you can kill off the first Berserk Slash.`}<br parentName="p"></br>{`
`}{`If that happens, I think you Energy Tint Sciel T1, on transition Intervention > Berserk Slash, and next turn standard Berserk Slash > Intervention.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Energy Tint Verso if Sciel/Lune target or AoE, Sciel if Verso target.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike / Berserk Slash`}</li>
      </ul>
      <p>{`Phase transitions here. `}<strong parentName="p">{`Notation is good / bad fight`}</strong>{`. Good fight is ONLY if Verso is targeted on his 1st attack.`}<br parentName="p"></br>{`
`}{`If good fight, parry everything. If not, dodge everything, you want to do less than half his HP on this turn.`}</p>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack or Tint Sciel / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike?`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso > Berserk Slash / Tint if needed, else nothing`}</li>
      </ul>
      <p>{`Good fight kills here.`}</p>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h4 {...{
        "id": "mediocre-fight-205"
      }}>{`Mediocre Fight (2:05)`}</h4>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Tint Verso`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you can transition with a parry, go for it.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike`}</li>
      </ul>
      <p>{`Phase change. Don't counter him this phase with this fight version, unless you transitioned off a parry and it's Verso target. In that case, play like the good fight 2nd phase.`}</p>
      <h5 {...{
        "id": "turn-21"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <p>{`Parry + Dodge AoE for AP generation.`}</p>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +2 (9)`}</li>
      </ul>
    </Menu>
    <p>{`Option 2 to sleep.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <p>{`Fight group before Monoco Station`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-troubador-gault-016"
      }}>{`Demineur, Troubador, Gault (0:16)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6890XP (NB), $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur 3 times.`}</li>
            <li parentName="ul">{`Defiant Strike Troubador`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Phantom Blade Gault`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Monoco.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-4"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > At Death's Door `}</li>
            <li parentName="ul">{`+Exposing Attack > First Strike (Swap)`}</li>
            <li parentName="ul">{`+Critical Moment > Inverted Affinity (No Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "monoco-station"
    }}>{`Monoco Station`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "monoco-111599hp-030"
      }}>{`Monoco 111599HP (0:30)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`54000XP, $4360, 3 Polished Chroma Catalyst + 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-7"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation `}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Watch Immolation damage, if it does 1233/1849 you're a level down and need to add damage.`}</p>
      </blockquote>
      <p>{`Dodge his Attack`}</p>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Stalact.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +First Strike`}</li>
            <li parentName="ul">{`-Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "stalact-51507hp-048"
      }}>{`Stalact 51507HP (0:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21600XP, $1744, Polished Chroma Catalyst + 0-1 Recoat`}<br parentName="p"></br>{`
`}{`Techically you can miss the kill if you Ice Lance since you have ~80% crit. If you want to be safe you can Wildfire, you just lose time to his animation of changing elements.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-8"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "old-lumiere"
    }}>{`Old Lumiere`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I > First Strike (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag by entrance.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +18 Agility (36)`}</li>
        <li parentName="ul">{`Verso: +18 Agility (28)`}</li>
        <li parentName="ul">{`Maelle: +21 Might (53)`}</li>
        <li parentName="ul">{`Sciel: +18 Luck (18)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Mayhem, +Elemental Trick`}</li>
        <li parentName="ul">{`Lune: Equip Elemental Trick Top-Left`}</li>
        <li parentName="ul">{`Verso: +Powerful, +Leadership`}</li>
        <li parentName="ul">{`Verso: Equip Leadership Left-Top, Powerful Left-Bottom`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chaliers-015"
      }}>{`Chaliers (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`13662XP, $998, Battlum LV10 + 0-2 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Verso outspeeds at 522 speed, 521 might work.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-9"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire left one (Default)`}</li>
        <li parentName="ul">{`Verso: Attack right one, Berserk Slash right one`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Auto Rush`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-140186hp-052"
      }}>{`Renoir 140186HP (0:52)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51750XP (NB), $4990, Melarum + 3 Polished Chroma Catalyst + 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Massive amount of chroma: Gradient once he jumps into the air.`}</li>
          <li parentName="ul">{`Melee combo: 5, 4th hit is later than it looks.`}</li>
          <li parentName="ul">{`Giant pool of chroma: jump`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 hit, look for slowdown.`}</li>
          <li parentName="ul">{`Vanish an expeditioner: Gradient before he strikes black orb.`}</li>
        </ul>
      </blockquote>
      <p>{`If Lune is under LVL20, replace the Ice Lance with Wildfire. Renoir will get an extra turn.`}</p>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Wildfire fail QTE`}</li>
        <li parentName="ul">{`Verso: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Healing Tonic Lune if she didn't crit herself / nothing / offensive shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership/Tonic. If you did Offensive Shift can just do the Leadership/Tonic`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <p><strong parentName="p">{`Talk to the Plazza Flag`}</strong>{`. Go to Joyous Mask (Back left)`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Lune, +Lune, -Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Auto Rush`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike > Energising Start`}</li>
            <li parentName="ul">{`+Confident Fighter > At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
            <li parentName="ul">{`+(R3) +At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Lanceram`}</li>
      </ul>
    </Menu>
    <p>{`Run into fight closest to flag.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-moisonneusse-hat-guy"
      }}>{`2 Moisonneusse Hat Guy`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Flee`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-5"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+Auto Rush > Combo Attack (Swap)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag, warp to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "visages-185114hp"
      }}>{`Visages 185114HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need 440 speed for phase 1`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Determination Mask: Parry, Jump, Parry. Very easy audio cues`}</li>
          <li parentName="ul">{`Build shields with Peace Mask: 4 Parries on audio cue`}</li>
          <li parentName="ul">{`Anxiety Mask: 2 Parry, slight delay from audio cue.`}</li>
          <li parentName="ul">{`Doubt Mask: 5 Parry, go off visual cues. 1st one is slower than it looks. Audio cue is too early.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot twice, Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter for damage.`}</p>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership`}</li>
        <li parentName="ul">{`Lune: (If damage low shoot 4 times), Wildfire (Finish Phase)`}</li>
      </ul>
      <h4 {...{
        "id": "mask-keeper-185114hp-200"
      }}>{`Mask Keeper 185114HP (2:00)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`157690XP, $11760, Immaculate + 6 Resplendent Chroma Catalyst x6 + 0-1 Recoat`}<br parentName="p"></br>{`
`}{`Need some amount of speed over 468.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attacks the Expedition: 4 Parries, visual cue off the circle build up of his attack.`}</li>
          <li parentName="ul">{`Swing Combo: 3 Parry, 2nd Parry tiny delay after 1st.`}</li>
          <li parentName="ul">{`Attacks like a Storm: 4 parries, visual/audio cue.`}</li>
          <li parentName="ul">{`Sets fire to his sword: 3 quick parries into a gradient`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-7"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership (If AoE parries for AP, skip after Attack)`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Forced Camp here. Go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +4 (13)`}</li>
        <li parentName="ul">{`Sciel: Scieleson +3 (8)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "sirene"
    }}>{`Sirene`}</h3>
    <p>{`Go to flag at entrance.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +15 Might (60)`}</li>
        <li parentName="ul">{`Lune: +15 Luck (25)`}</li>
        <li parentName="ul">{`Verso: +18 Might (50)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Take note if Sciel can't get 60 here. If so, you need to kill the Ballet fight for EXP. I recommend giving Maelle +6 Might (59) as well.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Sealed Fate, +Card Weaver`}</li>
        <li parentName="ul">{`Sciel: Equip Card Weaver Right-Bottom, Equip Sealed Fate Left-Bottom, Equip Twilight Slash Right-Middle`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Start battle with attack`}</strong>{` with a group of 2 or 3 Ballets. 2 is faster, 3 gives more XP.`}<br parentName="p"></br>{`
`}{`The attack prevents Verso getting a 2nd turn before they move.`}</p>
    <p>{`If Sciel is LVL26, you can run away with the 2nd party. If not, you need to kill until Sciel is LVL26 (should only take 1 fight).`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ballets-027"
      }}>{`Ballets (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21624XP (NB), $1410, Ballaro LV13`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-10"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Skip`}</li>
      </ul>
      <p>{`They should kill both characters`}</p>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Headshot each 3 times.`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door > Confident Fighter`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter > Augmented First Strike`}</li>
            <li parentName="ul">{`+Immaculate > Breaker`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "glissando-350757hp-104"
      }}>{`Glissando 350757HP (1:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51897XP, $2820, 1 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`515 speed seems to be the cutoff for him to not get 2 moves in T1.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Enchants its target: 1 hit. 2 explosions > Parry. Use rhythm.`}</li>
          <li parentName="ul">{`Smashes its head: 2 Parry, can visually/audio react`}</li>
          <li parentName="ul">{`Smashes its tail: 3 Parry, need to find cue. 1st visual on slowdown, 2nd audio, 3rd delayed audio.`}</li>
          <li parentName="ul">{`Summons ballets: 3 jumps, easy.`}</li>
          <li parentName="ul">{`Attacks with her fabric: one on each character, not sure on timing cue yet.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-11"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter. If "Smashes it's tail" parry, can replace Verso action with Powerful.`}<br parentName="p"></br>{`
`}{`If Enchant, might want to add a few shots for safety. If Verso target and no crit, add all shots.`}</p>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot till C Rank, Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Gradient > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sirene-303990hp-109"
      }}>{`Sirene 303990HP (1:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`129744XP, $7050, Tisseron + Energising Turn + Resplendent Chroma Catalyst x3`}<br parentName="p"></br>{`
`}{`She goes frantic at 80%? HP? After she does, her next move will be Grand Ballet.`}<br parentName="p"></br>{`
`}{`If you transition her there with a parry off her 1st move, she will skip her 2nd move.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Glissandos: 2 Parries`}</li>
          <li parentName="ul">{`Charm: 1 Parry, same timing as Glissando enchants. 2 Explosions > Parry`}</li>
          <li parentName="ul">{`Seduce: Gradient`}</li>
          <li parentName="ul">{`Grand Ballet: 5 Hits, watch ballets + audio cue. 1st one is earlier than you'd think, last one you have to be patient for.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-12"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Twilight Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If she goes frantic before her move, we did too much damage. Adjust with QTEs next time.`}</p>
      </blockquote>
      <p>{`Parry Glissando's, she should go frantic`}</p>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "the-monolith"
    }}>{`The Monolith`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`-Lune, -Verso, +Monoco, -Sciel`}</p>
    </Menu>
    <h4 {...{
      "id": "the-paintress"
    }}>{`The Paintress`}</h4>
    <p>{`Skip`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{` at the end of the `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{` section. It's behind the statue on the right.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`+Lune, +Verso, -Monoco, +Sciel`}</p>
      <h5 {...{
        "id": "weapon-6"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tisseron`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn > Combo Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to any flag along the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-7"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (45)`}</li>
        <li parentName="ul">{`Verso: +6 Agility (34) `}<em parentName="li">{`You can give more, it doesn't matter`}</em></li>
        <li parentName="ul">{`Sciel: +6 Agility (6)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-7"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Storm Caller`}</li>
        <li parentName="ul">{`Sciel: +All Set`}</li>
        <li parentName="ul">{`Sciel: Equip All Set Right-Top`}</li>
        <li parentName="ul">{`Lune: Equip Storm Caller Right-Top`}</li>
      </ul>
    </Menu>
    <p>{`In Lumiere, fight the first battle with Chevaliers.`}</p>
    <h4 {...{
      "id": "chevaliers"
    }}>{`Chevaliers`}</h4>
    <ul>
      <li parentName="ul">{`Lune Ice Lance, rest skip. Bring in 2nd party, flee.`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-2-370890hp-118"
      }}>{`Renoir 2 370890HP (1:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`724 Speed is the cutoff here. 732 doesn't work.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attempts to Vanish: 2 hit, Parry into Gradient. Parry right before he hits black orb. Gradient when back turned.`}</li>
          <li parentName="ul">{`Melee Combo: 6 hit, gradient last?`}</li>
          <li parentName="ul">{`Incredible amount of chroma: 2 Parries, Gradient. Parry as soon as you see the ball shrink.`}</li>
          <li parentName="ul">{`Waves of Chroma: 5 Parry, last is delayed`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 attacks, 1st 3 parry on slow down. 4th is ground pound.`}</li>
        </ul>
      </blockquote>
      <p>{`Dodge whatever attacks you can, don't want counter animations.`}</p>
      <h5 {...{
        "id": "turn-0-13"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Verso: Attack > 1 Shot, Leadership`}</li>
        <li parentName="ul">{`Sciel: Focused Fortell`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shots, Berserk Slash / Defiant Strike / Attack. You need to control damage here to get him as close to half as possible.`}</li>
        <li parentName="ul">{`Sciel: Shoot until 2 AP, Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`This should kill, if not get fucked.`}</p>
    </Menu>
    <p>{`Menu before Paintress`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Weakness Gain > Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-paintress-482157hp-409"
      }}>{`The Paintress 482157HP (4:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8519, Painted Power + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need >= 744 speed for Rush strat.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Void Meteors: 7 projectiles left to right. They kind of explode before launching, parry as soon as you see it.`}</li>
          <li parentName="ul">{`Gradient Attack: 1 Gradient`}</li>
          <li parentName="ul">{`Chroma Waves: 4 hits, 2nd one right after 1st. Audio cue works. Parry on start of cue.`}</li>
          <li parentName="ul">{`Scatters Chroma: 5 hits, parry once the black waves go into the circle. No more waves around circle > parry.`}</li>
          <li parentName="ul">{`Manipulates Rocks from the Monolith: 3 hit AoE, parry after the rock moves back?`}</li>
        </ul>
      </blockquote>
      <p>{`Parry only the AoE moves, and you can dodge 1 to avoid the counter unless noted otherwise.`}<br parentName="p"></br>{`
`}{`You want to slightly underdamage, so you can kill with the parry counter on her 4th move.`}</p>
      <h5 {...{
        "id": "turn-0-14"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Dodge Meteors`}</p>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: (Shoot and/or Attack for Rank C), Leadership`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: All Set`}</li>
      </ul>
      <p>{`Parry Gradient, Parry Chroma Waves and counter.`}</p>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate (Don't fail QTE)`}</li>
      </ul>
      <p>{`Parry all 5 chroma scatters, transition with counter.`}</p>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Summons giant brush of light: 3 hit aoe, parry on swing. Has audio cue similar to Chroma Waves`}</li>
          <li parentName="ul">{`Flies into the air: 5 hit, 2nd dodge on twirl, 3rd is slow, 4th is right after 3rd.`}</li>
          <li parentName="ul">{`Tears reality apart: 5 projectiles, dodge / parry at their "arc". Randomly start from left or right.`}</li>
          <li parentName="ul">{`Paintress unleashes: 7 single target into AoE`}</li>
          <li parentName="ul">{`Attacks from afar: Jump into 3 parry. Patient for jump`}</li>
        </ul>
      </blockquote>
      <p>{`You might not need all this damage, but you do need to keep doing stuff to generate Gradient`}</p>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`She will get 2 turns here. Giant brush > parry first 2 and perfect dodge 3rd.`}<br parentName="p"></br>{`
`}{`Dodge all the moves of flies into the air. No perfect dodges required, just survive.`}</p>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance (She outspeeds because Rush wore off for the others, might depend on speed)`}</li>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3-72323hp"
      }}>{`Phase 3 ~72323HP`}</h4>
      <p>{`Notation is Verso not healed / Verso healed. Verso not healed is ~2s faster.`}</p>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip / Attack`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Attack > Skip`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
      </ul>
    </Menu>
    <h2 {...{
      "id": "act-iii"
    }}>{`Act III`}</h2>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Talk to everyone, talk to campfire, Option 2`}</p>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <p>{`You can do this menu anytime before Creation.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Everyone except Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Confident Fighter (No Swap)`}</li>
            <li parentName="ul">{`+Auto Rush > Immaculate (No Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power > Critical Burn`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Confident Fighter > Dead Energy II`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-7"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel`}<ul parentName="li">
            <li parentName="ul">{`(L2) +Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`10 Polished Chroma Catalyst (10 total)`}</li>
        <li parentName="ul">{`4 Resplendent Chroma Catalyst (14 total)`}</li>
        <li parentName="ul">{`(If none owned) 1 Recoat`}</li>
      </ul>
    </Menu>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-8"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Recoat`}</strong>{`. +All Agility (96)`}</li>
        <li parentName="ul">{`Maelle: +6 Might (59) +18 Luck (18)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If under LVL28, you can add more Might. Not sure on exact limit, 62 is max at LVL28`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-8"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Last Chance, +Stendhall,`}</li>
        <li parentName="ul">{`Maelle: Equip Last Chance Left-Top, Equip Stendhall Left-Middle`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-3"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +11 (16)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "creation"
      }}>{`Creation`}</h4>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Flee`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`+Verso, -Maelle, +Maelle`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-3-766292hp-202"
      }}>{`Renoir 3 766292HP (2:02)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`219600XP, $9800`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul"><strong parentName="li">{`Phase 2 moves`}</strong>{`.`}</li>
          <li parentName="ul">{`Pool of Darkness: Ground Slam into 2 Explosions, simple audio cues.`}</li>
          <li parentName="ul">{`Void Meteors: 5 Projectiles, Pattern is BL TR BR TL. 1st is later than it looks, want to dodge as they hit ground.`}</li>
          <li parentName="ul">{`Attacks Frantically: 7 hit into Gradient`}</li>
          <li parentName="ul">{`Attacks Swiftly: 6 Single Target, 4 is right after 3`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-15"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: All Set`}</li>
        <li parentName="ul">{`Verso: Attack > 2 Shots, Leadership`}</li>
        <li parentName="ul">{`Maelle: Stendhall `}<strong parentName="li">{`(1.2 + 1.1 QTE)`}</strong>{`. Should do ~760000`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Gradient`}</li>
      </ul>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 1.1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhall `}<strong parentName="li">{`(1.2 + 1.2 QTE)`}</strong></li>
      </ul>
    </Menu>
    <p>{`Fight as Maelle.`}</p>
    <h4 {...{
      "id": "verso-157188hp-007"
    }}>{`Verso 157188HP (0:07)`}</h4>
    <p>{`Rain of Fire (Fail QTE)`}</p>
    <p>{`Time on fight end.`}</p>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <h4 {...{
      "id": "spring-meadows-lanceram-volester-abbest-70xp-216-019"
    }}>{`Spring Meadows Lanceram Volester Abbest 70XP $216 (0:19)`}</h4>
    <h5 {...{
      "id": "turn-0-16"
    }}>{`Turn 0`}</h5>
    <ul>
      <li parentName="ul">{`Gustav`}<ul parentName="li">
          <li parentName="ul">{`Shoot Volester 3 times to kill (main body, hitting weakness does less)`}</li>
          <li parentName="ul">{`Then shoot other weakpoints and attack Lanceram (default)`}</li>
        </ul></li>
      <li parentName="ul">{`Lune: Ice Lance Abbest (default)`}</li>
    </ul>
    <p>{`Parry Lanceram, Abbest dies to burn`}</p>
    <h4 {...{
      "id": "swc-rocher-3367hp-1575xpnb-316-011"
    }}>{`SWC Rocher 3367HP 1575XP(NB) $316 (0:11)`}</h4>
    <ul>
      <li parentName="ul">{`Lune: Wildfire (fail QTE) `}</li>
      <li parentName="ul">{`Gustav: Marking Shot`}</li>
      <li parentName="ul">{`Maelle: Percee`}</li>
    </ul>
    <h2 {...{
      "id": "timings"
    }}>{`Timings`}</h2>
    <h3 {...{
      "id": "spring-meadows-1"
    }}>{`Spring Meadows`}</h3>
    <p>{`The $720 chroma detour takes 11.5s.`}<br parentName="p"></br>{`
`}{`Empowering Attack Picto is ~15s detour after Eveque.`}</p>
    <h3 {...{
      "id": "esquies-nest-1"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Backtracking after Francois is 12s faster, but loses $1305 and Colour of Lumina.`}<br parentName="p"></br>{`
`}{`Flagging after Esquie saves ~13s, but loses Energising Start III.`}</p>
    <h3 {...{
      "id": "visages-1"
    }}>{`Visages`}</h3>
    <p>{`Killing self with Wildfire + Perfect Recovery > Flee: `}{`~`}{`14.5s`}<br parentName="p"></br>{`
`}{`Killing self with Wildfire + Perfect Recovery > 2nd party: `}{`~`}{`21s`}<br parentName="p"></br>{`
`}{`Killing self with 2 Moisonneusse (2 short combo) > `}{`~`}{`34s`}</p>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <p>{`Upgrading Healint Tint when near curator: 4s`}</p>
    <h2 {...{
      "id": "scribbles"
    }}>{`Scribbles`}</h2>
    <p>{`Sciel needs 18 Luck, can hold off on some of it till Renoir 2 if I want to invest more might.`}<br parentName="p"></br>{`
`}{`At LVL30, she will need 3 Agility 18 Luck to have EXACTLY enough for Paintress.`}<br parentName="p"></br>{`
`}{`Verso doesn't need to be the fastest for Paintress with Auto Rush (even though we're rushing ourselves). No idea why.`}</p>
    <p>{`Grim Harvest doesn't work on Faketress. Harvest does, but doesn't consume Foretell.`}</p>
    <p>{`Can probably delay Maelle might investment till Old Lumiere. Should hit just around the the threshold with marking shot and verso might investment.`}</p>
    <p>{`Looks like Sciel doesn't need any might to kill Gault with Phantom Blade`}</p>
    <p>{`Renoir 3 Setup: Don't touch Verso, give Sciel Weakness Gain and Auto Rush Lumina`}</p>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h5 {...{
      "id": "61325"
    }}>{`6/13/25`}</h5>
    <ul>
      <li parentName="ul">{`Add Inverted to Verso in Old Lumiere (was missing)`}</li>
      <li parentName="ul">{`Streamline Sciel's Lumina menus.`}</li>
    </ul>
    <h5 {...{
      "id": "61225"
    }}>{`6/12/25`}</h5>
    <ul>
      <li parentName="ul">{`Cut the Spring Meadows Lumina by the Portier. Lune gets 1 less now.`}</li>
      <li parentName="ul">{`Split the pre-Stalact menu into 2, doing the rest in Old Lumiere. This saves about 4s in fights, and fixes the Old Lumiere flag problem in the new patch`}</li>
      <li parentName="ul">{`In Old Lumiere, Verso and Maelle now get Inverted, Monoco gets First Strike, and Chevalier fight is improved.`}</li>
      <li parentName="ul">{`Confident Fighter menu updated to accomadate above changes.`}</li>
      <li parentName="ul">{`Sirene Ballets are now skipped by default, only killed if Sciel is missing a level`}</li>
      <li parentName="ul">{`Removed Lumina menu in Monolith. It's just Weapon + Pictos now.`}</li>
      <li parentName="ul">{`Changed Party Order for Renoir 2 & Paintress, Lune is now slot 1. Fights are adjusted accordingly.`}</li>
      <li parentName="ul">{`Paintress fight change, swapped Verso's action T0 and T2. He now skips T0 and Berserk Slashes T2. T1 he might need to shoot or worst case attack to build Rank for leadership.`}</li>
      <li parentName="ul">{`Moved Act 3 menu up, since it can be done early and is best done on a roll.`}</li>
    </ul>
    <h5 {...{
      "id": "61125"
    }}>{`6/11/25`}</h5>
    <ul>
      <li parentName="ul">{`Replaced Wildfire on Paintress with Elemental Trick (They are interchangable, but Wildfire is no longer equipped and Elemental Trick is faster in 1st row)`}</li>
      <li parentName="ul">{`Added notes for backups on Eveque and Ultimate Sakapatate`}</li>
    </ul>
    <h5 {...{
      "id": "61025"
    }}>{`6/10/25`}</h5>
    <ul>
      <li parentName="ul">{`Move Storm Caller and All Set to right top (saves inputs, sorry lol)`}</li>
      <li parentName="ul">{`Ice Lance on Monolith Chevaliers`}</li>
      <li parentName="ul">{`Paintress fight adjustment, Verso Berserk Slash T2 instead of T0. This let's you cut the attack T0`}</li>
    </ul>
    <h5 {...{
      "id": "60725"
    }}>{`6/07/25`}</h5>
    <ul>
      <li parentName="ul">{`Take different final fight for LVL3 before Eveque (thanks Luzbel)`}</li>
      <li parentName="ul">{`Use Degagement for tournament (thanks left_bishop)`}</li>
    </ul>
    <h5 {...{
      "id": "60625"
    }}>{`6/06/25`}</h5>
    <ul>
      <li parentName="ul">{`Lower Maelle might for Ren 3 for easier menuing`}</li>
      <li parentName="ul">{`Swap Maelle skill slots in Act 3`}</li>
      <li parentName="ul">{`Added note to flag before Robust Sakapatate if no missing Maelle XP`}</li>
    </ul>
    <h5 {...{
      "id": "60525"
    }}>{`6/05/25`}</h5>
    <ul>
      <li parentName="ul">{`Fix Medalum upgrade in Act 3 (15 > 16), thanks Maitreya.`}</li>
      <li parentName="ul">{`Move Elemental Trick to top left, Storm Caller and All Set to bottom right`}</li>
    </ul>
    <h5 {...{
      "id": "60425"
    }}>{`6/04/25`}</h5>
    <ul>
      <li parentName="ul">{`Fix Maelle Might attribution in act 3`}</li>
      <li parentName="ul">{`Add flag before Ultimate Sakapatate for Maelle might, remove Might upgrade in Gestral Village`}</li>
    </ul>
    <h5 {...{
      "id": "60425-1"
    }}>{`6/04/25`}</h5>
    <ul>
      <li parentName="ul">{`Use Defiant Strike on Chalier battle in Forgotten Battlefield (Marking Shot is 5HP short with no crits)`}</li>
      <li parentName="ul">{`Different slots for Sciel skills in Sirene`}</li>
      <li parentName="ul">{`Pre Renoir 2 menu, don't touch Lune pictos/lumina and give her 9 Agility at flag. Sciel gets All Set.`}</li>
      <li parentName="ul">{`Pre Paintress, no longer flag, give Lune speed by equipping Weakness Gain over Inverted Affinity. Inverted Affinity only adds like 5-6k damage in phase 1, so ok to lose.`}</li>
      <li parentName="ul">{`Paintress fight adjusted to use All Set (All Set T2, Verso skips T3)`}</li>
      <li parentName="ul">{`Act 3, buy 3 more Resplendant Catalysts.`}</li>
      <li parentName="ul">{`Maelle gets 62 Might now. Medalum gets upgraded to LVL16 now.`}</li>
      <li parentName="ul">{`Picto menu changed, so Verso doesn't go before Renoir 3.`}</li>
      <li parentName="ul">{`Creation strat now uses Intervention to flee instead of killing Maelle.`}</li>
      <li parentName="ul">{`Renoir 3 new strat, no longer breaks him, uses Gradient and stratigic QTEs to skip Canvas.`}</li>
    </ul>
    <h5 {...{
      "id": "60425-2"
    }}>{`6/04/25`}</h5>
    <ul>
      <li parentName="ul">{`Hotfix for some act 3 errors (thanks bdud5 for testing)`}</li>
      <li parentName="ul">{`Added missing menu before Creation`}</li>
      <li parentName="ul">{`Better Creation setup strat using Intervention`}</li>
      <li parentName="ul">{`Added missing Critical Moment for Sciel before Glissando.`}</li>
    </ul>
    <h5 {...{
      "id": "60325"
    }}>{`6/03/25`}</h5>
    <ul>
      <li parentName="ul">{`Fix some errors (thanks bdud5)`}</li>
      <li parentName="ul">{`Old Lumiere stat attributions, Sciel supposed to get luck not might.`}</li>
      <li parentName="ul">{`Added missing instructions for suicide fight in Visages`}</li>
      <li parentName="ul">{`Fix typo in Monolith stat attributions, Sciel gets 6 Agility, not 61`}</li>
      <li parentName="ul">{`Commit to no Might / +15 Agility Lune for Renoir 2/Paintress`}</li>
    </ul>
    <h5 {...{
      "id": "60325-1"
    }}>{`6/03/25`}</h5>
    <ul>
      <li parentName="ul">{`Big "reroute", main focus is getting Auto Rush and a more efficient suicide before Mask Keeper. I'll list all the changes here since there are quite a few.`}</li>
      <li parentName="ul">{`Francois: Sciel gets 45 Might`}</li>
      <li parentName="ul">{`Lampmaster: Sciel gets Breaker`}</li>
      <li parentName="ul">{`Camp after Lampmaster: `}<ul parentName="li">
          <li parentName="ul">{`Maelle no longer gets Might (menuing timesave).`}</li>
          <li parentName="ul">{`Verso gets 1 less might, 1 more agility.`}</li>
          <li parentName="ul">{`Verso learns Perfect Recovery, no longer learns Powerful`}</li>
        </ul></li>
      <li parentName="ul">{`Stalact: Sciel no longer gets First Strike Picto, equips it as Lumina`}</li>
      <li parentName="ul">{`Old Lumiere:`}<ul parentName="li">
          <li parentName="ul">{`Verso now gets Powerful here.`}</li>
          <li parentName="ul">{`Pick up Auto Rush.`}</li>
        </ul></li>
      <li parentName="ul">{`Visages:`}<ul parentName="li">
          <li parentName="ul">{`Menus here completely restructured.`}</li>
          <li parentName="ul">{`Now self-kill Verso & Lune and flee with Sciel from setup fight.`}</li>
          <li parentName="ul">{`Menu after setup fight changed too, need to adjust Verso weapon and swap a picto.`}</li>
        </ul></li>
      <li parentName="ul">{`Sirene: `}<ul parentName="li">
          <li parentName="ul">{`Stat adjustments.`}</li>
          <li parentName="ul">{`Attack Ballets to start battle, so Verso doesn't get an extra turn.`}</li>
        </ul></li>
      <li parentName="ul">{`Monolith:`}<ul parentName="li">
          <li parentName="ul">{`Menu adjustments`}</li>
          <li parentName="ul">{`Stat adjustments`}</li>
          <li parentName="ul">{`No longer learn All Set`}</li>
        </ul></li>
      <li parentName="ul">{`Paintress:`}<ul parentName="li">
          <li parentName="ul">{`T2 Rush instead of All Set`}</li>
          <li parentName="ul">{`Counter Chroma Waves now`}</li>
          <li parentName="ul">{`Verso T3 just Powerful, Sciel no longer fails Sealed Fate`}</li>
        </ul></li>
      <li parentName="ul">{`Act 3:`}<ul parentName="li">
          <li parentName="ul">{`Shop: Buy Recoat if none owned`}</li>
          <li parentName="ul">{`New menus`}</li>
          <li parentName="ul">{`Setup on Creation without party wipe using Last Chance + Healing Tint`}</li>
          <li parentName="ul">{`Renoir 3 fight changed around not having All Set (it's faster now)`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "60125"
    }}>{`6/01/25`}</h5>
    <ul>
      <li parentName="ul">{`Default to not remove Dodger from Lune & Verso. Added note to remove it if behind on EXP`}</li>
      <li parentName="ul">{`Update best fight times for Renoir 2, Mask Keeper`}</li>
      <li parentName="ul">{`Fix some typos/incorrect names.`}</li>
    </ul>
    <h5 {...{
      "id": "53025"
    }}>{`5/30/25`}</h5>
    <ul>
      <li parentName="ul">{`Fix some issues (thanks Bdud5)`}</li>
    </ul>
    <h5 {...{
      "id": "53025-1"
    }}>{`5/30/25`}</h5>
    <ul>
      <li parentName="ul">{`Another small Paintress phase 1 optimization`}</li>
      <li parentName="ul">{`Updates some best fight times`}</li>
    </ul>
    <h5 {...{
      "id": "52925"
    }}>{`5/29/25`}</h5>
    <ul>
      <li parentName="ul">{`Small Paintress phase 3 optimization`}</li>
      <li parentName="ul">{`Updates some best fight times`}</li>
    </ul>
    <h5 {...{
      "id": "52825"
    }}>{`5/28/25`}</h5>
    <ul>
      <li parentName="ul">{`Just updated some fight times.`}</li>
    </ul>
    <h5 {...{
      "id": "52725"
    }}>{`5/27/25`}</h5>
    <ul>
      <li parentName="ul">{`Better Sirene fight with Sealed Fate`}</li>
      <li parentName="ul">{`Adjusted skill learning order for above`}</li>
      <li parentName="ul">{`Remove 1 shot from Paintress fight before Berserk Slash`}</li>
    </ul>
    <h5 {...{
      "id": "52725-1"
    }}>{`5/27/25`}</h5>
    <ul>
      <li parentName="ul">{`Fixed extra Death's Door addition on Sciel before Glissando`}</li>
      <li parentName="ul">{`Fixed Francois strat, was non-medalum start in notes`}</li>
      <li parentName="ul">{`Lanceram Volester Abbest fight now uses Ice Lance instead of Immolation`}</li>
      <li parentName="ul">{`Pre Eveque Lune stats adjusted to 8 Might 1 Agility`}</li>
    </ul>
    <h5 {...{
      "id": "52625"
    }}>{`5/26/25`}</h5>
    <ul>
      <li parentName="ul">{`Cut Energising Start III`}</li>
      <li parentName="ul">{`Added middle-ground Dualiste strat for bad targetting in phase 1.`}</li>
    </ul>
    <h5 {...{
      "id": "52625-1"
    }}>{`5/26/25`}</h5>
    <ul>
      <li parentName="ul">{`Switch stat/picto setup for Eveque. Ends up the same as before in Manor menu.`}</li>
      <li parentName="ul">{`Added note to parry Robust Sakapate shield attack`}</li>
      <li parentName="ul">{`Updated times and HP values for bosses (HP values according to Gearboxed's spreadsheet)`}</li>
      <li parentName="ul">{`Fixed a few lumina menu issues (Dodger)`}</li>
      <li parentName="ul">{`Adjusted lumina / money route (pick up Lumina in Spring Meadows, skip money and lumina in Esquie's nest`}</li>
    </ul>
    <h5 {...{
      "id": "52525"
    }}>{`5/25/25`}</h5>
    <ul>
      <li parentName="ul">{`Move merchant in Visages to Lumiere`}</li>
      <li parentName="ul">{`Skip Dualiso upgrade, Scielson to LV8 instead of 9`}</li>
      <li parentName="ul">{`Added note to shoot Glissando if needed`}</li>
      <li parentName="ul">{`Added All Set to Sciel Skill menu`}</li>
      <li parentName="ul">{`Updated Paintress fight to use All Set. Fundamentally the same, just faster.`}</li>
      <li parentName="ul">{`Buy 10 Polished Chroma Catalysts from Merchant`}</li>
      <li parentName="ul">{`Upgrade Medalum to 15 instead of Barrier Breaker to 18, use that for Act III`}</li>
      <li parentName="ul">{`Added Maelle death to Creation`}</li>
      <li parentName="ul">{`Renoir 3 strat updated to break him`}</li>
      <li parentName="ul">{`Verso is now just Rain of Fire`}</li>
    </ul>
    <h5 {...{
      "id": "52325"
    }}>{`5/23/25`}</h5>
    <ul>
      <li parentName="ul">{`Fixed Lune missing First Strike Lumina in Monolith menu`}</li>
      <li parentName="ul">{`Put Dodger back on Lune earlier (no reason not to)`}</li>
      <li parentName="ul">{`Updated a few fight times.`}</li>
      <li parentName="ul">{`Improved 2 Lancelier fight.`}</li>
      <li parentName="ul">{`Re-ordered flag and normal menu before Renoir 3.`}</li>
    </ul>
    <h5 {...{
      "id": "52225"
    }}>{`5/22/25`}</h5>
    <ul>
      <li parentName="ul">{`Notes Complete!`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      